
// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';

// configure Swiper to use modules
Swiper.use([ Navigation, Pagination, Autoplay, EffectFade ]);

const testimonialsSwiper = new Swiper('.js-ma-testimonials-swiper', {
    // Optional parameters
    loop: false,
    slidesPerView: 1,
    spaceBetween: 0,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },

    // Navigation arrows
    navigation: {
        nextEl: '.js-ma-testimonials-button-next',
        prevEl: '.js-ma-testimonials-button-prev'
    }
});
